import { createContext } from 'react';
import { QUERY_KEYS_OBJECTS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/objects/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/objects/rankings/byDepartment'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/objects/rankings/bySectional'
        },
        filterParams
    );

    const rankByCity = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_CITY,
            url: 'governanceroom/securitydashboard/objects/rankings/byCity'
        },
        filterParams
    );

    const rankByNeighbourhood = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_NEIGHBOURHOOD,
            url: 'governanceroom/securitydashboard/objects/rankings/byNeighborhood'
        },
        filterParams
    );

    const rankByObjectType = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_TYPES,
            url: 'governanceroom/securitydashboard/objects/rankings/byTypes'
        },
        filterParams
    );

    const rankByBrand = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_RANKINGS_BRANDS,
            url: 'governanceroom/securitydashboard/objects/rankings/byBrands'
        },
        filterParams
    );


    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byCity: rankByCity.data || [],
        byNeighbourhood: rankByNeighbourhood.data || [],
        byObjectType: rankByObjectType.data || [],
        byBrand: rankByBrand.data || [],
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
